<template>
    <div id="app">
        <Header></Header>
        <Article></Article>
        <Footer></Footer>
    </div>


</template>

<script>

    import Header from "./components/Header";
    import Footer from "./components/Footer";
    import BlockC from "./components/BlockC";
    import Services from "./components/Services";
    import Blog from "./components/Blog";
    import Article from "./components/Article";



    export default {
        name: 'app',

        data: () => ({}),
        components: {
            Article,
            Blog,
            Services,
            BlockC,
            Footer,
            Header,


        }
    }
</script>
